<template>
	<div class="w-full max-w-6xl mx-auto px-8 pt-12 pb-20 lg:pt-20 md:flex">
		<div class="md:w-1/2">
			<h1 class="type-1000 font-70 text-secondary md:type-1200 md:max-w-md">
				{{ heading }}
			</h1>
			<p class="type-1000 font-70 mb-10 md:mb-16 md:type-1200 md:max-w-md">
				{{ subheading }}
			</p>
			<div class="text-mono-300 mb-10">{{ uiCopy.allFields }}</div>
		</div>
		<div class="md:w-1/2">
			<form class="w-full max-w-md">
				<div class="w-full mb-4 mb-4 md:mb-8">
					<label class="text-mono-300" for="firstName">{{
						uiCopy.firstName
					}}</label>
					<input
						required
						v-model="firstName"
						id="firstName"
						type="text"
						class="custom-input"
						ref="firstName"
					/>
				</div>
				<div class="w-full mb-4 md:mb-8">
					<label class="text-mono-300" for="lastName">{{
						uiCopy.lastName
					}}</label>
					<input
						required
						v-model="lastName"
						id="lastName"
						type="text"
						class="custom-input"
					/>
				</div>
				<div class="mb-10 w-full md:mb-24">
					<button
						@click="checkForm"
						class="btn-primary w-full"
						type="submit"
						:disabled="!disabled || !firstName || !lastName"
					>
						{{ uiCopy.ready }}
					</button>
				</div>
			</form>
			<p>{{ privacy }}</p>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			firstName: null,
			lastName: null,
		}
	},
	props: {
		heading: String,
		subheading: String,
		privacy: String,
		disabled: Boolean,
		uiCopy: Object,
	},
	methods: {
		checkForm: function (ev) {
			ev.preventDefault()
			if (this.firstName && this.lastName) {
				this.$emit('slide-next', this.firstName, this.lastName)
			}
		},
	},
	mounted: function () {
		this.$refs.firstName.focus()
	},
}
</script>
